const type = 'SET_RECHARGE_SMS_SENDING';

const setRechargeSMSSending = (data) => ({
  data,
  type,
});

export default setRechargeSMSSending;
